import clsx from 'clsx'
import kebabCasify from 'lib/string/kebabCasify'

type ResponsiveValues<Value extends string | number> = { [v in App.ScreenSize]?: Value }

export type ResponsiveClassNameGetter<Value extends string | number> = (values: ResponsiveValues<Value> | Value) => string

function createResponsiveClassNameGetter<Value extends string | number>(
  /**
   * The base string to be used for generated class names.
   *
   * _will be kebab-cased_
   */
  base: string,
): ResponsiveClassNameGetter<Value> {
  const kebabCaseBase = kebabCasify(base)

  return (arg) => {
    if (typeof arg !== 'object') {
      return `${kebabCaseBase}-${arg}`
    }
    const {
      mobile,
      tablet,
      desktop,
      largeDesktop,
      extraLargeDesktop,
    } = arg
    return clsx(
      mobile !== undefined ? `${kebabCaseBase}-${mobile}` : undefined,
      tablet !== undefined ? `tablet-${kebabCaseBase}-${tablet}` : undefined,
      desktop !== undefined ? `desktop-${kebabCaseBase}-${desktop}` : undefined,
      largeDesktop !== undefined ? `large-desktop-${kebabCaseBase}-${largeDesktop}` : undefined,
      extraLargeDesktop !== undefined ? `extra-large-desktop-${kebabCaseBase}-${extraLargeDesktop}` : undefined,
    )
  }
}

export default createResponsiveClassNameGetter
